import ApiService from './ApiService';

class CartApi extends ApiService {
    constructor() {
        super('carts');
    }

    /**
     * Get all cart items for the current user
     */
    getAllCarts() {
        return this.get('');
    }

    /**
     * Get pre-checkout cart information
     * @param publicationIds Array of publication IDs to checkout
     */
    getPreCheckoutCart(publicationIds: string[]) {
        // pre-checkout-cart is a separate endpoint at root level, not under /carts
        // Use a new ApiService instance with empty base URL to call absolute path
        const preCheckoutApi = new ApiService();
        return preCheckoutApi.post('pre-checkout-cart', { publicationIds });
    }

    /**
     * Add item to cart
     * @param publicationId Publication ID to add to cart
     */
    addToCart(publicationId: number) {
        return this.post('', { publicationId });
    }

    /**
     * Delete item from cart
     * @param publicationId Publication ID to remove from cart
     */
    deleteToCart(publicationId: number) {
        return this.delete(`${publicationId}`);
    }
}

export const cartApi = new CartApi();
export default CartApi;
